import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import WarningIcon from '@material-ui/icons/Warning';
import { styled } from "@material-ui/styles";
import { useIO, useModel } from '@type-r/react';
import { Link, navigate } from "lqx-react";
import { Loading } from 'lqx-react/lib/flex.js';
import { asDateTimeUTC } from "lqx-react/src/formatters.js";
import React, { useState } from 'react';
import { ImportJobStatusType } from "../import-jobs/models/ImportJobStatusType.js";
import { DigiTooltip, limitText } from "../shared.js";
import { ImportTemplateActivityDto } from "../api/importTemplateActivityLog";

export const ImportTemplateActivitiesTab = ({ importTemplateId }) => {
    const activities = useModel(ImportTemplateActivityDto);
    const [activitiesData, setActivitiesData] = useState([]) as any;

    const statusFormatter = (status) => {
        if (status === ImportJobStatusType.Processed) {
            return <IconSuccess />;
        }
        if (status === ImportJobStatusType.Processing || status === ImportJobStatusType.Reprocessing) {
            return <IconWarning />;
        }
        if (status === ImportJobStatusType.ErrorProcessing || status === ImportJobStatusType.Closed) {
            return <IconError />;
        }
    };

    const isReady = useIO(async () => {
        let result = null;
        await activities.get(importTemplateId)
            .then(card => result = card)
            .catch(err => {
                console.log('Error occured when fetch connection activities');
            });
        setActivitiesData(result.items);
    }, [])

    return (
        isReady && activitiesData ? activitiesData.length ? (
            <Table aria-label="simple table">
                <TableHead>
                    <TableRowStyled>
                        <HeaderCell style={{ width: '40px' }}>
                        </HeaderCell>
                        <HeaderCell>
                            Processed On
                        </HeaderCell>
                        <HeaderCell>
                            Job Id
                        </HeaderCell>
                        <HeaderCell>
                            File Name
                        </HeaderCell>
                    </TableRowStyled>
                </TableHead>
                <TableBody>
                    {activitiesData.map(i => (
                        <TableRow key={i.id}>
                            <RowCell align={'center'}>
                                <DigiTooltip title={i.importJobStatus}>
                                    {statusFormatter(i.importJobStatus)}
                                </DigiTooltip>
                            </RowCell>
                            <RowCell>{asDateTimeUTC(i.processedOn)}</RowCell>
                            <RowCell>
                                <Link href="" onClick={() => navigate(`ingest/edit/${i.id}`)}>{i.id}</Link>
                            </RowCell>
                            <RowCell>
                                {
                                    i.fileName.length > 35
                                        ?
                                        <DigiTooltip title={i.fileName}>
                                            <span>{limitText(i.fileName, 35)}</span>
                                        </DigiTooltip>
                                        :
                                        i.fileName
                                }
                            </RowCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        ) : (<NoItems>No Items</NoItems>) : <Loading />
    )
}

const TableRowStyled = styled(TableRow)({
    background: 'rgb(231, 242, 249)',
    borderBottom: '2px solid #F2F5F8',
    borderTop: '1px solid #F2F5F8',
})

const HeaderCell = styled(TableCell)({
    fontFamily: 'Montserrat',
    padding: '0',
    height: '28px',
    color: '#63a9dc',
    fontSize: '13px',
    lineHeight: '15px',
})

const RowCell = styled(TableCell)({
    fontFamily: 'Montserrat',
    padding: '0',
    height: '28px',
    color: '#829AB0',
    fontSize: '12px',
    lineHeight: '15px',
})

const IconSuccess = styled('div')({
    width: '10px',
    height: '10px',
    background: '#43B252',
    borderRadius: '15px',
    marginLeft: '13.5px'
});


const IconWarning = styled(WarningIcon)({
    color: '#eabc5e',
    paddingRight: '3px'
});

const IconError = styled(WarningIcon)({
    color: '#ea5e5e',
    paddingRight: '3px'
});

const NoItems = styled('div')({
    width: '100%',
    textAlign: 'center',
    padding: '10px 0 10px 0',
});